// eslint-disable-next-line import/no-anonymous-default-export
export default function (url, options, timeout = 300000) { //change to 5 mins
  return Promise.race([
    fetch(url, options),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("timeout")), timeout)
    ),
  ]);
}
